export default "__VITE_ASSET__7f141c38__"